import { AbstractControl } from "@angular/forms";
import { ValidatorFn } from "@angular/forms";

export class ProfileValidator {
    /**
     * @method matchPassword
     * @description custom form group validator to check if password fields match
     * @param {AbstractControl} AC
     * @returns {any}
     */
    static matchPassword(control: AbstractControl) {
        const newPassword = control.get("newPassword");
        const confirmPassword = control.get("confirmPassword"); // to get value in input tag

        if (
            !newPassword?.value ||
            !confirmPassword?.value ||
            newPassword.value.length === 0 ||
            confirmPassword.value.length === 0
        ) {
            // both values not set
            return null;
        }

        if(newPassword.value === confirmPassword.value && confirmPassword.errors?.matchPassword){
            confirmPassword.updateValueAndValidity();
        }
        return newPassword.value !== confirmPassword.value
            ? confirmPassword.setErrors({ matchPassword: true })
            : null;
    }

    static newPassword(control: AbstractControl) {
        const newPassword = control.get("newPassword");
        const password = control.get("password"); // to get value in input tag

        if (
            !newPassword?.value ||
            !password?.value ||
            newPassword.value.length === 0 ||
            password.value.length === 0
        ) {
            // both values not set
            return null;
        }

        return newPassword.value === password.value
            ? newPassword.setErrors({ newPassword: true })
            : null;
    }

    /**
     * @method matchEmail
     * @description custom form group validator to check if emails match
     * @param {AbstractControl} AC
     * @returns {any}
     */
    static matchEmail(control: AbstractControl) {
        const email = control.get("email"); // to get value in input tag
        const confirmEmail = control.get("confirmEmail"); // to get value in input tag

        if (!(email && confirmEmail)) {
            // both values not set
            return null;
        }

        return email.value !== confirmEmail.value
            ? confirmEmail.setErrors({ matchEmail: true })
            : null;
    }
}

/**
 * @method PwdLength
 * @description checks to see if password length is between 8 and 64 characters (inclusive of bounds)
 * @returns {ValidatorFn}
 * @constructor
 */
export function PwdLength(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        const code = control.value;

        if (code == null) {
            // Do nothing, value has not been set. Use Required validator
            // to ensure value has been entered;
            return null;
        }

        const pattern: RegExp = new RegExp(".{8,256}");
        const correctLength = pattern.test(code);

        if (correctLength) {
            return null;
        } else {
            if (location.href.includes("profile/edit")) {
                // only profile editor requires this since there's 3 different validators duking it out
                control.setErrors({ pwdLength: true });
            }
            return { pwdLength: true };
        }
    };
}
